import React from "react";
import { css, styled } from "styled-components";

import { typeScale } from "lib/themeUtils";

const small = css`
  ${typeScale.sm};
  color: ${(props) => props.theme.colours.bodyLight};
`;

const hidden = css`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

const StyledLabel = styled.label<{ $small?: boolean; $visuallyHidden?: boolean }>`
  ${typeScale.md};

  display: block;
  margin-bottom: 0.5rem;
  font-weight: bold;

  ${(props) => props.$small && small}
  ${(props) => props.$visuallyHidden && hidden}

  span {
    margin-left: 0.5rem;
    color: ${(props) => props.theme.colours.bodyLight};
  }
`;

export const FieldLabel: React.FC<
  { small?: boolean; visuallyHidden?: boolean } & React.LabelHTMLAttributes<HTMLLabelElement>
> = ({ visuallyHidden, ...props }) => <StyledLabel $visuallyHidden={visuallyHidden} {...props} />;
